// top navbarhighlight the main active nav link
$(document).ready(function() {
  $('#navbar-main .navbar-nav li a').each(function () {
      if ($(this).prop('href') == window.location.href) {        
         $(this).closest("li").addClass("active");        
      }
  });
});

/*   SIDEBAR  */
$(document).ready(function() {
  $("#sidebarButton").on("click", function() {
    $("#sidebar").toggleClass("side-menu");
    if ($("#sidebar").hasClass("side-menu")) {
      $("#toggleIcon").removeClass("fa-angle-double-right");
      $("#toggleIcon").addClass("fa-angle-double-left");
    } else {
      $("#toggleIcon").removeClass("fa-angle-double-left");
      $("#toggleIcon").addClass("fa-angle-double-right");
    }
  });

  if ($("#sidebar").hasClass("side-menu")) {
    $("#toggleIcon").removeClass("fa-angle-double-right");
    $("#toggleIcon").addClass("fa-angle-double-left");
  } else {
    $("#toggleIcon").removeClass("fa-angle-double-left");
    $("#toggleIcon").addClass("fa-angle-double-right");
  }
});

//var snav = document.getElementById("sidebar");
var show = document.getElementsByClassName("act");
for (var i = 0; i < show.length; i++) {
  show[i].addEventListener("click", function() {
    var current = document.getElementsByClassName("active");
    current[0].className = current[0].className.replace("active", "");
    this.className += " active";
  });
}

/*-------- Popover ----------------------*/
$(document).ready(function() {
  $('[data-toggle="popover"]').popover();
});

//Select all checkboxes
$(function() {
  $("#checkAll").change(function() {
    $(".item-id").prop("checked", $(this).prop("checked"));
  });
});

$(function() {
  $('[data-toggle="tooltip"]').tooltip();
});

//open specific tab on another page
$(document).ready(function() {
  var hash = window.location.hash;
  hash && $('ul.nav a[href="' + hash + '"]').tab("show");
});

$(function() {
  $("#addperms").on("click", function() {
    $("#perms :selected").each(function(i, selected) {
      var text = $(this).text();
      var value = $(this).val();
      $(".perms-text").prepend(
        "<span class='removeperms badge badge-info mr-1' data-id='" +
          value +
          "'>" +
          text +
          " <i class='fa fa-times' aria-hidden='true'></i></span>"
      );
    });
  });

  $("body").on("click", ".removeperms", function() {
    var id = $(this).data("id");
    $(this).remove();
    $("#perms :selected").each(function(i, selected) {
      if ($(this).val() == id) {
        $("select option[value='" + id + "']").prop("selected", false);
      }
    });
  });
});

/* $(document).ready(function(){

  var current_tab, next_tab //tab-panes
  var opacity;

  $(".next").click(function(){
      current_tab = $(this).parent();
      next_tab = $(this).parent().next();

      //Add Class Active
      $("#step-bar li").eq($(".tab-pane").index(next_tab)).addClass("active");
      //show the next .tab-pane
      next_tab.show();
      //hide the current .tab-pane with style
      current_tab.animate({opacity: 0}, {
      step: function(now) {
          // animation
          opacity = 1 - now;
          current_tab.css({
          'display': 'none',
          'position': 'relative'
          });
          next_tab.css({'opacity': opacity});
          },
          duration: 600
      });
  });
  $(".submit").click(function(){
  return false;
  })
}); */

/** btn-next btn-previous (career page) */
$(document).ready(function() {
  $('.btn-next').click(function() {
    $('.nav-tabs .active').parent().next('li').find('a').trigger('click');
  });

  $('.btn-previous').click(function() {
    $('.nav-tabs .active').parent().prev('li').find('a').trigger('click');
  });
});


// Appointments rating stars
$(document).ready(function($){	    
    $(".btnrating").on('click',(function(e) {  
       	var previous_value = $("#app_selected_rating").val();  
		var selected_value = $(this).attr("data-attr");
		   
  		$("#app_selected_rating").val(selected_value); 
  		$(".selected-rating").empty();
  		$(".selected-rating").html(selected_value);
  
  		for (i = 1; i <= selected_value; ++i) {
  			$("#rating-star-"+i).toggleClass('btn-edit');
  			$("#rating-star-"+i).toggleClass('btn-light');
  		}
  
  		for (ix = 1; ix <= previous_value; ++ix) {
  			$("#rating-star-"+ix).toggleClass('btn-edit');
  			$("#rating-star-"+ix).toggleClass('btn-light');
  		} 
  	}));      
});

// email connection testing
$(document).ready(function() {
  $('#email_connection_test').on('click', function(e) {
    e.preventDefault();

    let params = {};
    params.email_comms_config_server = $('input[name=email_comms_config_server]').val();
    params.email_comms_config_port = $('input[name=email_comms_config_port]').val();
    params.email_comms_config_username = $('input[name=email_comms_config_username]').val();
    params.email_comms_config_password = $('input[name=email_comms_config_password]').val();
    params.email_comms_config_encryption = $('select[name=email_comms_config_encryption]').val();
    params.email_comms_config_sender_name = $('input[name=email_comms_config_sender_name]').val();
    params.email_comms_config_sender_address = $('input[name=email_comms_config_sender_address]').val();
    params.email_comms_config_reply_to_name = $('input[name=email_comms_config_reply_to_name]').val();
    params.email_comms_config_reply_to_address = $('input[name=email_comms_config_reply_to_address]').val();
    params.email_comms_test_email = $('input[name=email_comms_test_email]').val();
    let token =$('meta[name="csrf-token"]').attr('content');
    $('#email_connection_test').prop('disabled', true);
    $('#email_connection_test .spinner-border').removeClass('hidden');
    $.ajax({
      method: "POST",
      url: '/admin/comms/email/test',
      data: params,
      dataType: 'json',
      headers: {'X-CSRF-TOKEN': token}
    }).done(function(data) {
      if (data.error) {
        $('#email_connection_test_result').addClass('text-danger');
        $('#email_connection_test_result').removeClass('text-success');
      } else {
        $('#email_connection_test_result').removeClass('text-danger');
        $('#email_connection_test_result').addClass('text-success');
      }
      $('#email_connection_test_result').html(data.message);
    }).fail(function(error) {
      $('#email_connection_test_result').addClass('text-danger');
      $('#email_connection_test_result').removeClass('text-success');
      $('#email_connection_test_result').html('An Unknown Error Occurred');
    }).always(function(){
      $('#email_connection_test').prop('disabled', false);
      $('#email_connection_test .spinner-border').addClass('hidden');
    });
  });
});

// videos
jQuery(document).ready(function() {
  jQuery("#tutorial_type").change(function() {
      if (jQuery(this).val() === 'video'){ 
          jQuery('div[name=youtube]').show();   
      } else {
          jQuery('div[name=youtube]').hide(); 
      }
  });
});

//show spinner icon 
$(document).ready(function() {
  $(".btn-spinner").click(function() {
   /*  // disable button
    $(this).prop("disabled", true); */
    // add spinner to button
    $(this).html(`<i class='fa fa-spinner fa-lg fa-spin'></i> Refreshing `);
  });
});

/** Counter */
$(document).ready(function () {
	let manage = document.getElementById('front-counter');
	if(manage) {
		var counted = 0;
		$(window).scroll(function() {
			var oTop = $('#front-counter').offset().top - window.innerHeight;
			if (counted == 0 && $(window).scrollTop() > oTop) {
				$('.count-number').each(function() {
					var $this = $(this), countTo = $this.attr('data-count');
				$({countNum: $this.text()}).animate({countNum: countTo},
					{
					duration: 2000,
					easing: 'swing',
					step: function() { $this.text(Math.floor(this.countNum)); },
					complete: function() { $this.text(this.countNum); }
					});
				});
				counted = 1;
			}
		});
	}
});

/* Contact form AJAX */
$(document).ready(function () {
  	$('#contactForm').on('submit', function(e){
    	e.preventDefault();
      $.ajaxSetup({
          headers: {
            'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
          }
      });
      $.ajax({
        url: $(this).attr('action'),
        method: $(this).attr('method'),
        data: new FormData(this),
        processData: false,
        dataType: 'json',
        contentType: false,
        beforeSend:function(){
            $(document).find('span.text-danger').text('');
            document.getElementById('sendMessageId').className = 'fas fa-sync fa-spin';
        },
        success:function(data){
            if(data.status ==422){
                $.each(data.error, function(prefix, val){
                    $('span.'+prefix+'_error').text(val[0]);
                });
            } else {
                $('#contactForm')[0].reset();
                $('#btn-send').attr('disabled', false);
				        let success = '<p class="alert alert-success">' + data.success + '</p'; 
				        $('#res').html(success).show("slow").delay(8000).hide("slow");
            }
            document.getElementById('sendMessageId').className = 'fa fa-paper-plane'
        }
    });
 	 })
});
/** hero section on modal close stop play video */
$(document).ready(function () {
    $("#modalVideo").on('hidden.bs.modal', function (e) {
    $("#modalVideo iframe").attr("src", $("#modalVideo iframe").attr("src"));
});
});
/** scroll to top */
$('#backToTopBtn').click(function(){
  $('html,body').animate({scrollTop:0},'slow');return false;
});

/** change button up/down icon */
$(document).ready(function () {
  $('.up-down').on('click', function(){
    $(this).find('i').toggleClass("fa-chevron-up fa-chevron-down");
  })
});

/** Show more.../ show less... text */
$(document).ready(function () {
  $(function(){ 
  $('.fulltext').each(function(event){
    var max_length = 200; /* max content length before a read more link */
    if($(this).html().length > max_length){ 
      var short_content   = $(this).html().substr(0,max_length); 
      var long_content  = $(this).html().substr(max_length);
      $(this).html(short_content+'...<a href="#" class="read_more"> Show More</a>'+
      '<span class="more_text" style="display:none;">'+long_content+'</span>'+
      '<a href="#" class="read_less" style="display:none;"> Show Less</a>'); 
      $(this).find('a.read_more').click(function(event){ 
      event.preventDefault(); 
      $(this).hide(); /* hide the read more button */
      $('.read_less').show(); /* show read less button */
      $(this).parents('.fulltext').find('.more_text').show(); /* show the .more_text span */
    });

          $(this).find('a.read_less').click(function(event){ 
            event.preventDefault();
      $(this).hide(); 
      $('.read_less').hide();
      $('.read_more').show();
            $(this).parents('.fulltext').find('.more_text').hide();
          });
        }
  });
  });
});

//check all student activities
  $(document).ready(function(){
    $('#checkAllActivities').attr('checked', true); 
    $('.checkActivity').attr('checked', true); 
    $('#checkAllActivities').click(function () {    
      $('.checkActivity').prop('checked', this.checked);    
    });  
  });